exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-099e37d5]:export{menuText:#bfcbd9;menuActiveText:#409EFF;subMenuActiveText:#f4f4f5;menuBg:#304156;menuHover:#263445;subMenuBg:#1f2d3d;subMenuHover:#001528;sideBarWidth:210px;bgColor:#F2F3F5;fontColor:#409EFF;searchBg:#fff}.text-link[data-v-099e37d5]{color:#409EFF;cursor:pointer}.detail-list .detail-list-page[data-v-099e37d5]{text-align:right}\n", ""]);

// exports
